module.exports = __webpack_public_path__ + "assets/img/simply-Brand_02.ff75a478.png";